import React from 'react';
import { useFormikContext } from 'formik';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import { RecommendationBar } from '../../../components/Shared';
import { InterviewCiting } from '../../../components/citing/InterviewCiting';
import { InterviewRoleOptions, MethodRadioOption, TabHeaders } from '../constants';
import { ContributorSection } from '../../../components/ContributorSection';
import GenericSection from '../../../components/GenericSection';
import { PubMainTypeEnum } from '../../../types';
import { ONLINE_PUBINFO_SECTION_FIELDS } from '../constants/fieldList/online';
var Website = function Website() {
  var _values$interview;
  var WEBSITE_SECTION_TITLE_TEST_ID = 'website-pub-section-test-id';
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var METHOD = (_values$interview = values.interview) === null || _values$interview === void 0 ? void 0 : _values$interview.type;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(InterviewCiting, {
    selectedTab: TabHeaders.WEBSITE
  }), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: InterviewRoleOptions
  }), METHOD === MethodRadioOption.OTHER && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenericSection, {
    name: PubMainTypeEnum.PUB_ONLINE,
    sectionTitle: "Website publication info",
    fieldList: ONLINE_PUBINFO_SECTION_FIELDS,
    "data-test": WEBSITE_SECTION_TITLE_TEST_ID,
    selectedTab: TabHeaders.WEBSITE
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null)));
};
export default Website;